import React, { useCallback, useEffect, useRef, useState } from "react";

// 勤怠マイページ共通トースト（会議2026-07・案B＝黒バー）。
// emitToast(msg, type) で発火し、MypageLayout に置いた <ToastHost/> が
// 画面右上（スマホは上部）に position:fixed で浮かせて表示し、数秒で自動的に消す。
// in-flow の .mp-msg と違いレイアウトの高さを変えないので、アクションのたびに画面が動かない。
// type: "success"（緑チェック）/ "error"（赤×）/ "info"（グレーi）。既定は success。

const EVT = "mp-toast";
const DURATION = 2800; // 表示時間(ms)。この後スライドアウトして消える。
const LEAVE = 340; // スライドアウトのアニメーション時間(ms)。

// どこからでも呼べるトースト発火。フックではないのでイベントハンドラ内で直接使える。
export function emitToast(msg, type = "success") {
  if (!msg) return;
  window.dispatchEvent(new CustomEvent(EVT, { detail: { msg, type } }));
}

const Icon = {
  success: () => (<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M8.4 12.2l2.4 2.4 4.8-5.2" strokeLinecap="round" strokeLinejoin="round" /></svg>),
  error: () => (<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M9 9l6 6M15 9l-6 6" strokeLinecap="round" /></svg>),
  info: () => (<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 7.6h.01" strokeLinecap="round" /></svg>),
};

// トーストの表示ホスト。MypageLayout に1つだけ置く。
// 直近の1件を表示し、新しいトーストが来たら差し替える（連続操作で積み上がらない）。
export function ToastHost() {
  const [toast, setToast] = useState(null); // { id, msg, type, leaving }
  const timers = useRef({});

  const clearTimers = () => { clearTimeout(timers.current.out); clearTimeout(timers.current.hide); };

  // スライドアウト → アニメ後に除去。
  const dismiss = useCallback(() => {
    clearTimeout(timers.current.out);
    setToast((t) => (t ? { ...t, leaving: true } : null));
    timers.current.hide = setTimeout(() => setToast(null), LEAVE);
  }, []);

  useEffect(() => {
    const onEvt = (e) => {
      const { msg, type } = e.detail || {};
      if (!msg) return;
      clearTimers();
      setToast({ id: Date.now() + Math.random(), msg, type: type || "success", leaving: false });
      timers.current.out = setTimeout(() => {
        setToast((t) => (t ? { ...t, leaving: true } : null));
        timers.current.hide = setTimeout(() => setToast(null), LEAVE);
      }, DURATION);
    };
    window.addEventListener(EVT, onEvt);
    return () => { window.removeEventListener(EVT, onEvt); clearTimers(); };
  }, []);

  if (!toast) return null;
  const I = Icon[toast.type] || Icon.success;
  return (
    <div className="mp-toast-root" aria-live="polite" aria-atomic="true">
      {/* クリック（タップ）でも消せる。×ボタンは置かず自動消滅＋タップで閉じる。 */}
      <div
        className={`mp-toast mp-toast-${toast.type} ${toast.leaving ? "mp-toast-out" : "mp-toast-in"}`}
        role="status"
        onClick={dismiss}
      >
        <span className="mp-toast-ic"><I /></span>
        <span className="mp-toast-msg">{toast.msg}</span>
      </div>
    </div>
  );
}
